import { isAdminAppPath } from "@/lib/adminAppPath";
import { writePersistedUserLanguage } from "@/lib/languagePolicy";
import { reportSiteLanguageConsoleOnce } from "@/lib/siteDebug";
import { getEffectiveSiteLanguage } from "@/lib/siteLanguage";
import { usesSpanishDefaultForSite } from "@/lib/siteGeoPolicy";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * i18n: detectores + siteGeoPolicy. Reconciliación: español por defecto si usesSpanishDefaultForSite() y i18n no es es.
 */
export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!i18n.isInitialized) return;
    if (isAdminAppPath()) return;
    if (!usesSpanishDefaultForSite()) return;
    const base = (i18n.language || "").toLowerCase().split("-")[0];
    if (base === "es") return;
    void i18n.changeLanguage("es");
  }, [i18n, i18n.isInitialized, i18n.language]);

  useEffect(() => {
    if (!i18n.isInitialized || !i18n.language) return;
    reportSiteLanguageConsoleOnce();
  }, [i18n.isInitialized, i18n.language]);

  useEffect(() => {
    if (!i18n.language) return;
    const doc = getEffectiveSiteLanguage(i18n.language);
    document.documentElement.lang = doc;
    document.documentElement.setAttribute("data-lang", doc);
    writePersistedUserLanguage(doc);
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) {
      ogLocale.setAttribute("content", doc.replace(/-/g, "_"));
    }
  }, [i18n.language]);

  return <>{children}</>;
};
